export default __webpack_public_path__ + "static/media/save-flag.c6dcd684.svg";